module.exports = __webpack_public_path__ + "img/carousel-mulinobianco.png?71bd2265d9714e2ba34515f1bd1c7520";